export default {
  API_URL: 'https://rohw.gjuss.zp.ua',
  ROUTE_PREFIX: '',
  CAPTCHA_KEY: '6LeW1foZAAAAAAryfC9khxApNOnTzqdH4yYPmJIm',
  ZSS_PAY_URL: 'https://ips24.zss.zp.ua/faces/api/proc?t=Ei2yB6Ryl-_7AZhwAAXJu0cDxnrlhUufR2OHtiQGzkw.&b=',
}